import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import itemActions from "./actions.js";
import { successAlert, errorAlert } from "../Alerts/actions";
import {
  GET_ITEMS,
  ITEM_SAVE,
  ITEMS_VIEW_MODAL_OPEN_AND_FETCH,
  ITEMS_EDIT_MODAL_OPEN_AND_FETCH,
  ITEM_EDIT,
  DELETE_ITEM,
} from "./constants";
const {
  getItemsPending,
  getItemsSuccess,
  getItemsFailure,
  saveItemPending,
  saveItemSuccess,
  saveItemFailure,
  editItemPending,
  editItemSuccess,
  editItemFailure,
  itemsModalSetItem,
  deleteItemPending,
  deleteItemSuccess,
  deleteItemFailure,
} = itemActions;

//To get items by userid
export function* getItems({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(getItemsPending({ isItemsLoading: true }));
  try {
    const { data } = yield call(api(token).get, `/api/items?all=true`);
    yield put(getItemsSuccess(data));
  } catch (e) {
    yield put(errorAlert("Error while retrieving items!"));
    yield put(getItemsFailure({ error: e }));
  }
}

export function* saveItem({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(saveItemPending({ isItemSaving: true }));
  try {
    const saveResponse = yield call(api(token).post, `/api/items/add`, payload);
    yield put(saveItemSuccess({ message: saveResponse.message }));
    yield put(successAlert("Item saved successfully!"));
  } catch (error) {
    yield put(
      errorAlert(typeof error === "string" ? error : "Error while saving item!")
    );
    yield put(saveItemFailure({ error: error }));
  }
}

export function* openItemsViewModal({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/items/${payload}`);
    if (data && data.id) {
      yield put(itemsModalSetItem(data));
    }
  } catch (e) {
    yield put(errorAlert("Error while retrieving item!"));
  }
}

// using a single action to set role for view and edit
export function* openItemsEditModal({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const isViewModalOpen = yield select(
    (state) => state?.ItemReducer?.isViewModalOpen
  );
  const currentItem = yield select((state) => state?.ItemReducer?.currentItem);
  try {
    if (isViewModalOpen) {
      yield put(itemsModalSetItem(currentItem));
    } else {
      const { data } = yield call(api(token).get, `/api/items/${payload}`);
      if (data && data.id) {
        yield put(itemsModalSetItem(data));
      }
    }
  } catch (error) {
    yield put(errorAlert("Error while retrieving item!"));
  }
}

export function* editItem({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const currentItem = yield select((state) => state?.ItemReducer?.currentItem);
  yield put(editItemPending({ isItemSaving: true }));
  try {
    const saveResponse = yield call(
      api(token).post,
      `/api/items/edit/${currentItem.id}`,
      payload
    );
    yield put(editItemSuccess({ message: saveResponse.message }));
    yield put(successAlert("Item edited successfully!"));
  } catch (error) {
    yield put(
      errorAlert(
        typeof error === "string" ? error : "Error while editing item!"
      )
    );
    yield put(editItemFailure({ error: error }));
  }
}

export function* deleteItem({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(deleteItemPending({ isItemDeleting: true }));
  try {
    const deleteResponse = yield call(
      api(token).delete,
      `api/items/${payload}`
    );
    yield put(deleteItemSuccess({ message: deleteResponse.message }));
    yield put(successAlert("Item deleted successfully!"));
  } catch (error) {
    yield put(
      errorAlert(
        typeof error === "string" ? error : "Error while deleting item!"
      )
    );
    yield put(deleteItemFailure({ error: error }));
  }
}
export function* watchLoadItems() {
  yield takeEvery(GET_ITEMS, getItems);
}

export function* watchSaveItem() {
  yield takeEvery(ITEM_SAVE, saveItem);
}

export function* openItemsViewModalFlow() {
  yield takeEvery(ITEMS_VIEW_MODAL_OPEN_AND_FETCH, openItemsViewModal);
}

export function* openItemsEditModalFlow() {
  yield takeEvery(ITEMS_EDIT_MODAL_OPEN_AND_FETCH, openItemsEditModal);
}

export function* watchEdirItem() {
  yield takeEvery(ITEM_EDIT, editItem);
}

export function* watchDeleteItem() {
  yield takeEvery(DELETE_ITEM, deleteItem);
}

export default function* itemsSaga() {
  yield all([
    watchLoadItems(),
    watchSaveItem(),
    openItemsViewModalFlow(),
    openItemsEditModalFlow(),
    watchEdirItem(),
    watchDeleteItem(),
  ]);
}
